export default "__VITE_ASSET__CbhEeiGa__"